export const CORPORATE_ONBOARDING_CARE_NEAR_YOU_ACTION = {
  CONTINUE: 'continue',
  BROWSE_SITTERS: 'browse_sitters',
  SHARE_NEEDS: 'share_needs',
} as const;

export type CorporateOnboardingCareNearYouAction =
  (typeof CORPORATE_ONBOARDING_CARE_NEAR_YOU_ACTION)[keyof typeof CORPORATE_ONBOARDING_CARE_NEAR_YOU_ACTION];

export const EMPLOYER_BENEFIT_CALLOUT_TEXT =
  "Your employer covers the cost of a Premium Membership, so you won't pay any fees to message sitters or request basic background checks.";

export const MIN_SITTER_COUNT_FOR_HEADLINE = 30;

export const LOW_SITTER_COUNT_HEADLINE = 'We found sitters in your area!';

export const SITTER_COUNT_FETCH_ERROR_HEADLINE = "We couldn't load sitter availability right now.";
